import React, {Component} from "react";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core/styles";
import List from "@material-ui/core/List";

import LevelWithIcon from "./level-with-icon";
import SkeletonLevel from "../play-screen/skeleton-level";
import {PLAY_SCREEN} from '../../ducks/duck-screen'


const styles = theme => ({
	root: {

	},
	levelList: {
		'padding-bottom': '100px',
	}
});

class ExtraLevelsScreen extends Component {
	currentPosition = 0;
	state = {};

	setCurrentPosition = ({ target }) => {
		this.currentPosition = target.scrollTop;
	};

	componentDidMount() {
		const { scrollPositions,
			allLevelPropertiesDownloaded,
			allUserLevelsDownloaded,
			fetchAllLevelsProperties,
			fetchAllUserLevels,
			uid } = this.props;
		//zerujemy pozycje na liscie lóg
		const container = document.querySelector('#extra-container').closest("#animation-wrapper");
		container.addEventListener('scroll', this.setCurrentPosition);
		if(scrollPositions["extra"]){
			container.scrollTop = scrollPositions["extra"];
		} else {
			container.scrollTop = 0;
		}

		if(!allLevelPropertiesDownloaded){
			fetchAllLevelsProperties();
		}

		if(!allUserLevelsDownloaded && uid){
			fetchAllUserLevels()
		}
	}

	componentWillUnmount() {
		const { updateScrollPosition } = this.props;
		const container = document.querySelector('#extra-container');
		container.removeEventListener('scroll', this.setCurrentPosition);
		// console.log('pozycja logo-screen', this.currentPosition);
		console.log( "extra", this.currentPosition);
		updateScrollPosition(this.currentPosition, "extra");
	}

	changeToExtraLevelLogos = (gameType, extraLevel) => {
		// fetchGameTypeUserLevels(gameType);
		const { setCurrentGameType, push, setCurrentExtraLevel } = this.props;
		setCurrentExtraLevel(extraLevel);
		setCurrentGameType(gameType);
		push(PLAY_SCREEN);
	};

	renderLevels = (levelList) => {
		const { collectedRiddlesForGameType,
			collectedRiddlesForAllLevels,
			riddleCountForGameType } = this.props;

		return levelList.map(extraLevel => {

			return (
				<LevelWithIcon
					key={`extra-level-${extraLevel.lp}`}
					levelName={`${extraLevel.gameType}`}
					color={extraLevel.color}
					levelIcon={extraLevel.levelIcon}
					gameType={extraLevel.gameType}
					unlockLimit={extraLevel.unlockLimit}
					riddleLimit={riddleCountForGameType[extraLevel.gameType]}
					collectedRiddles={collectedRiddlesForGameType[extraLevel.gameType] || 0} //TODO
					collectedPoints={extraLevel.collectedPoints || 0}
					riddlesCountingForUnlock={collectedRiddlesForAllLevels}
					isUnlocked={collectedRiddlesForAllLevels >= extraLevel.unlockLimit}
					// isUnlocked={false}//TODO
					isSound={this.props.isSound}
					isVibrate={this.props.isVibrate}
					onClick={() => { this.changeToExtraLevelLogos(extraLevel.gameType, extraLevel)}}
				/>
			);
		});
	};

	renderSkeletons = () => {
		return [...Array(10).keys()].map(i => {
			return (<SkeletonLevel
				key={`level-${i}`}
				id={`level-${i}`}
			/>)
		})
	};

	render(){
		const { classes,
			extraLevels,
			allUserLevelsDownloaded } = this.props;


		const areLevelsDownloaded = extraLevels.length > 0 && allUserLevelsDownloaded;
		const style = areLevelsDownloaded ? {} : { overflow: "hidden" };

		return (
			<div className={classes.root} id={"extra-container"} style={style}>
				<List component="ul" className={classes.levelList}>
					{!areLevelsDownloaded && this.renderSkeletons()}
					{areLevelsDownloaded && this.renderLevels(extraLevels)}
					</List>
			</div>
		);
	}
}


ExtraLevelsScreen.propTypes = {
	allUserLevelsDownloaded: PropTypes.bool.isRequired,
	allLevelPropertiesDownloaded: PropTypes.bool.isRequired,
	isSound: PropTypes.bool.isRequired,
	isVibrate: PropTypes.bool.isRequired,
	collectedRiddlesForAllLevels: PropTypes.number.isRequired,
	uid: PropTypes.string.isRequired,

	extraLevels: PropTypes.array.isRequired,
	scrollPositions: PropTypes.object.isRequired,
	collectedRiddlesForGameType: PropTypes.object.isRequired,
	riddleCountForGameType: PropTypes.object.isRequired,
	gameTypesProperties: PropTypes.object.isRequired,

	push: PropTypes.func.isRequired,
	fetchAllUserLevels: PropTypes.func.isRequired,
	setCurrentGameType: PropTypes.func.isRequired,
	setCurrentExtraLevel: PropTypes.func.isRequired,
};

export default withStyles(styles)(ExtraLevelsScreen);